import { render, staticRenderFns } from "./FormInputSelectDilazioneWidget.vue?vue&type=template&id=6bf9f1b8&"
import script from "./FormInputSelectDilazioneWidget.vue?vue&type=script&lang=js&"
export * from "./FormInputSelectDilazioneWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports